import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'

export const SEARCH_QUERY_PARAM_KEY = 'search_query'

export const SEARCH_RESULTS_POSTS_FILTER_SUB_MENU = 'newsboard'

export const SEARCH_RESULTS_POSTS_EXCLUDE_FILTERS = [FILTER_NAME_SUB_MENU]

export const QA_NAME_SEARCH_RESULTS_POSTS = 'searchResultsPosts'
